// PROGRAM: Portal — Member/guest detection, progress bars, tier badges, clock
// Replaces member-portal.js

(function() {
    'use strict';

    var Portal = {
        clockEl: null,
        clockInterval: null,

        init: function() {
            this.clockEl = document.getElementById('portal-clock');
            if (this.clockEl) {
                this.updateClock();
                var self = this;
                this.clockInterval = setInterval(function() { self.updateClock(); }, 60000);
            }

            // Update progress bar from CartOS/PROGRAMS.Cart
            this.updateProgressBar();

            // Listen for cart updates — renders the SAME CartOS into the member terminal
            if (window.PROGRAMS && PROGRAMS.on) {
                var self = this;
                PROGRAMS.on('cart:updated', function(cart) {
                    self.updateProgressBarFromCart(cart);
                    self.updateMemberCart(cart);
                });
            }

            // Also hook into CartOS.render so the member terminal mirrors the drawer
            var Cart = window.PROGRAMS && PROGRAMS.Cart ? PROGRAMS.Cart : window.CartOS;
            if (Cart && Cart.render) {
                var self = this;
                var originalRender = Cart.render.bind(Cart);
                Cart.render = function(cart) {
                    originalRender(cart);
                    self.updateMemberCart(cart);
                };
                // Initial render from cached cart
                if (Cart.cachedCart) {
                    self.updateMemberCart(Cart.cachedCart);
                }
            }

            // Mobile fix
            this.applyMobileFix();
        },

        updateClock: function() {
            if (!this.clockEl) return;

            var now = new Date();
            var months = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
            var dateStr = months[now.getMonth()] + ' ' + String(now.getDate()).padStart(2, '0') + ', ' + now.getFullYear();

            // Calculate moon phase (simplified)
            var lp = 2551443;
            var newMoon = new Date(1970, 0, 7, 20, 35, 0);
            var phase = ((now.getTime() - newMoon.getTime()) / 1000) % lp;
            var phasePercent = phase / lp;
            var moonIcon = '🌑';
            if (phasePercent < 0.0625) moonIcon = '🌑';
            else if (phasePercent < 0.1875) moonIcon = '🌒';
            else if (phasePercent < 0.3125) moonIcon = '🌓';
            else if (phasePercent < 0.4375) moonIcon = '🌔';
            else if (phasePercent < 0.5625) moonIcon = '🌕';
            else if (phasePercent < 0.6875) moonIcon = '🌖';
            else if (phasePercent < 0.8125) moonIcon = '🌗';
            else if (phasePercent < 0.9375) moonIcon = '🌘';
            else moonIcon = '🌑';

            var phaseName = 'NEW MOON';
            if (phasePercent < 0.0625) phaseName = 'NEW MOON';
            else if (phasePercent < 0.1875) phaseName = 'WAXING CRESCENT';
            else if (phasePercent < 0.3125) phaseName = 'FIRST QUARTER';
            else if (phasePercent < 0.4375) phaseName = 'WAXING GIBBOUS';
            else if (phasePercent < 0.5625) phaseName = 'FULL MOON';
            else if (phasePercent < 0.6875) phaseName = 'WANING GIBBOUS';
            else if (phasePercent < 0.8125) phaseName = 'LAST QUARTER';
            else if (phasePercent < 0.9375) phaseName = 'WANING CRESCENT';
            else phaseName = 'NEW MOON';

            this.clockEl.innerHTML = dateStr + ' • ' + moonIcon + ' ' + phaseName;
        },

        updateProgressBar: function() {
            var Cart = window.PROGRAMS && PROGRAMS.Cart ? PROGRAMS.Cart : window.CartOS;
            if (!Cart) return;

            var progressFill = document.getElementById('portal-progress-fill');
            var tiersEl = document.getElementById('portal-tiers');
            var progressLabel = document.getElementById('portal-progress-label');

            if (progressFill && Cart.cachedCart) {
                this.updateProgressBarFromCart(Cart.cachedCart);
            }
        },

        updateProgressBarFromCart: function(cart) {
            var Cart = window.PROGRAMS && PROGRAMS.Cart ? PROGRAMS.Cart : window.CartOS;
            if (!Cart) return;

            var progressFill = document.getElementById('portal-progress-fill');
            var tiersEl = document.getElementById('portal-tiers');
            var progressLabel = document.getElementById('portal-progress-label');

            if (!progressFill) return;

            var total = cart.total_price / 100;
            var thresholds = Cart.savingsThresholds;
            var maxThreshold = thresholds[thresholds.length - 1].amount;
            var progress = Math.min((total / maxThreshold) * 100, 100);
            progressFill.style.width = progress + '%';

            // Update tiers
            if (tiersEl) {
                var currentTierIndex = -1;
                for (var i = 0; i < thresholds.length; i++) {
                    if (total >= thresholds[i].amount) currentTierIndex = i;
                }
                var tiersHtml = '<tr>';
                thresholds.forEach(function(tier, index) {
                    var bgColor = '#E0E0E0';
                    var borderColor = '#FFF';
                    if (total >= tier.amount) {
                        bgColor = '#90EE90';
                        borderColor = '#006600';
                    } else if (index === currentTierIndex + 1) {
                        bgColor = '#FFFF90';
                        borderColor = '#AA8800';
                    }
                    tiersHtml += '<td align="center" width="25%" style="background:' + bgColor + ';border:2px outset ' + borderColor + '"><font face="Arial" size="1">' + tier.icon + '<br><b>' + tier.label + '</b><br>$' + tier.amount + '</font></td>';
                });
                tiersHtml += '</tr>';
                tiersEl.innerHTML = tiersHtml;
            }

            // Update label
            if (progressLabel) {
                var nextTier = null;
                var needed = 0;
                for (var i = 0; i < thresholds.length; i++) {
                    if (total < thresholds[i].amount && !nextTier) {
                        nextTier = thresholds[i];
                        needed = thresholds[i].amount - total;
                    }
                }
                if (total === 0) {
                    progressLabel.innerHTML = '<font face="Arial" size="1" color="#006600"><i>Add items to unlock savings!</i></font>';
                } else if (nextTier) {
                    progressLabel.innerHTML = '<font face="Arial" size="1" color="#006600"><i>Next: ' + nextTier.reward + ' ($' + needed.toFixed(2) + ' to go)</i></font>';
                } else {
                    progressLabel.innerHTML = '<font face="Arial" size="1" color="#006600"><b>🎉 MAXIMUM SAVINGS UNLOCKED!</b></font>';
                }
            }
        },

        updateMemberCart: function(cart) {
            // Use the EXACT SAME CartOS as the drawer — call CartOS.generateHTML()
            var Cart = window.PROGRAMS && PROGRAMS.Cart ? PROGRAMS.Cart : window.CartOS;
            var container = document.getElementById('member-cart-cartos-content');
            if (!container || !Cart) return;

            // Render the same HTML that the drawer uses
            if (Cart.generateHTML) {
                container.innerHTML = Cart.generateHTML(cart);
            }

            // Update the title bar item count
            var countEl = document.getElementById('member-cart-count');
            if (countEl) countEl.textContent = cart.item_count;

            console.log('[PROGRAMS Portal] Member cart updated via CartOS: ' + cart.item_count + ' items');
        },

        applyMobileFix: function() {
            if (window.innerWidth <= 999) {
                var css = document.createElement('style');
                css.id = 'portal-mobile-fix-inline';
                css.textContent = [
                    '.portal-section { width: 100% !important; max-width: 100% !important; margin: 0 !important; margin-left: 0 !important; margin-right: 0 !important; padding: 4px !important; box-sizing: border-box !important; }',
                    '.portal-section > table, .portal-section > div, .marching-ants-cart { width: 100% !important; max-width: 100% !important; margin-left: 0 !important; margin-right: 0 !important; box-sizing: border-box !important; }',
                    '.portal-section table[width="100%"] { table-layout: fixed !important; width: 100% !important; }',
                    '.portal-section table[width="100%"] table { table-layout: auto !important; }',
                    '.portal-section td[width="50%"] { width: 50% !important; max-width: 50% !important; box-sizing: border-box !important; }',
                    '.portal-section td[width="33%"] { width: 33.33% !important; max-width: 33.33% !important; box-sizing: border-box !important; }',
                    '.portal-section * { max-width: 100vw; }'
                ].join('\n');
                document.head.appendChild(css);

                document.querySelectorAll('.portal-section').forEach(function(el) {
                    el.style.cssText = 'width: 100% !important; max-width: 100% !important; margin: 0 !important; margin-left: 0 !important; margin-right: 0 !important; padding: 4px !important; box-sizing: border-box !important;';
                });
                document.querySelectorAll('.marching-ants-cart').forEach(function(el) {
                    el.style.cssText = 'width: 100% !important; max-width: 100% !important; margin-left: 0 !important; margin-right: 0 !important; box-sizing: border-box !important;';
                });
                console.log('[PROGRAMS Portal] Mobile fix applied');
            }
        }
    };

    // Register with PROGRAMS
    window.PROGRAMS.register('Portal', Portal);

})();
